/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { PlatformApiResultOfAnnouncementDto } from '../models/platform-api-result-of-announcement-dto';
import { PlatformApiResultOfDataSourceResultDtoOfAnnouncementDto } from '../models/platform-api-result-of-data-source-result-dto-of-announcement-dto';
import { deleteNotificationsAnnouncements } from '../fn/announcement/delete-notifications-announcements';
import { DeleteNotificationsAnnouncements$Params } from '../fn/announcement/delete-notifications-announcements';
import { getNotificationsAnnouncementsId } from '../fn/announcement/get-notifications-announcements-id';
import { GetNotificationsAnnouncementsId$Params } from '../fn/announcement/get-notifications-announcements-id';
import { postNotificationsAnnouncements } from '../fn/announcement/post-notifications-announcements';
import { PostNotificationsAnnouncements$Params } from '../fn/announcement/post-notifications-announcements';
import { postNotificationsAnnouncementsQueryDatasource } from '../fn/announcement/post-notifications-announcements-query-datasource';
import { PostNotificationsAnnouncementsQueryDatasource$Params } from '../fn/announcement/post-notifications-announcements-query-datasource';
import { putNotificationsAnnouncements } from '../fn/announcement/put-notifications-announcements';
import { PutNotificationsAnnouncements$Params } from '../fn/announcement/put-notifications-announcements';

@Injectable({ providedIn: 'root' })
export class PlatformAnnouncementService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `postNotificationsAnnouncementsQueryDatasource()` */
  static readonly PostNotificationsAnnouncementsQueryDatasourcePath = '/api/notifications/announcements/query/datasource';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `postNotificationsAnnouncementsQueryDatasource()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  postNotificationsAnnouncementsQueryDatasource$Response(params: PostNotificationsAnnouncementsQueryDatasource$Params, context?: HttpContext): Observable<StrictHttpResponse<PlatformApiResultOfDataSourceResultDtoOfAnnouncementDto>> {
    return postNotificationsAnnouncementsQueryDatasource(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `postNotificationsAnnouncementsQueryDatasource$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  postNotificationsAnnouncementsQueryDatasource(params: PostNotificationsAnnouncementsQueryDatasource$Params, context?: HttpContext): Observable<PlatformApiResultOfDataSourceResultDtoOfAnnouncementDto> {
    return this.postNotificationsAnnouncementsQueryDatasource$Response(params, context).pipe(
      map((r: StrictHttpResponse<PlatformApiResultOfDataSourceResultDtoOfAnnouncementDto>): PlatformApiResultOfDataSourceResultDtoOfAnnouncementDto => r.body)
    );
  }

  /** Path part for operation `getNotificationsAnnouncementsId()` */
  static readonly GetNotificationsAnnouncementsIdPath = '/api/notifications/announcements/{id}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getNotificationsAnnouncementsId()` instead.
   *
   * This method doesn't expect any request body.
   */
  getNotificationsAnnouncementsId$Response(params: GetNotificationsAnnouncementsId$Params, context?: HttpContext): Observable<StrictHttpResponse<PlatformApiResultOfAnnouncementDto>> {
    return getNotificationsAnnouncementsId(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getNotificationsAnnouncementsId$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getNotificationsAnnouncementsId(params: GetNotificationsAnnouncementsId$Params, context?: HttpContext): Observable<PlatformApiResultOfAnnouncementDto> {
    return this.getNotificationsAnnouncementsId$Response(params, context).pipe(
      map((r: StrictHttpResponse<PlatformApiResultOfAnnouncementDto>): PlatformApiResultOfAnnouncementDto => r.body)
    );
  }

  /** Path part for operation `putNotificationsAnnouncements()` */
  static readonly PutNotificationsAnnouncementsPath = '/api/notifications/announcements';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `putNotificationsAnnouncements()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  putNotificationsAnnouncements$Response(params: PutNotificationsAnnouncements$Params, context?: HttpContext): Observable<StrictHttpResponse<PlatformApiResultOfAnnouncementDto>> {
    return putNotificationsAnnouncements(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `putNotificationsAnnouncements$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  putNotificationsAnnouncements(params: PutNotificationsAnnouncements$Params, context?: HttpContext): Observable<PlatformApiResultOfAnnouncementDto> {
    return this.putNotificationsAnnouncements$Response(params, context).pipe(
      map((r: StrictHttpResponse<PlatformApiResultOfAnnouncementDto>): PlatformApiResultOfAnnouncementDto => r.body)
    );
  }

  /** Path part for operation `postNotificationsAnnouncements()` */
  static readonly PostNotificationsAnnouncementsPath = '/api/notifications/announcements';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `postNotificationsAnnouncements()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  postNotificationsAnnouncements$Response(params: PostNotificationsAnnouncements$Params, context?: HttpContext): Observable<StrictHttpResponse<PlatformApiResultOfAnnouncementDto>> {
    return postNotificationsAnnouncements(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `postNotificationsAnnouncements$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  postNotificationsAnnouncements(params: PostNotificationsAnnouncements$Params, context?: HttpContext): Observable<PlatformApiResultOfAnnouncementDto> {
    return this.postNotificationsAnnouncements$Response(params, context).pipe(
      map((r: StrictHttpResponse<PlatformApiResultOfAnnouncementDto>): PlatformApiResultOfAnnouncementDto => r.body)
    );
  }

  /** Path part for operation `deleteNotificationsAnnouncements()` */
  static readonly DeleteNotificationsAnnouncementsPath = '/api/notifications/announcements';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `deleteNotificationsAnnouncements()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  deleteNotificationsAnnouncements$Response(params: DeleteNotificationsAnnouncements$Params, context?: HttpContext): Observable<StrictHttpResponse<PlatformApiResultOfAnnouncementDto>> {
    return deleteNotificationsAnnouncements(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `deleteNotificationsAnnouncements$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  deleteNotificationsAnnouncements(params: DeleteNotificationsAnnouncements$Params, context?: HttpContext): Observable<PlatformApiResultOfAnnouncementDto> {
    return this.deleteNotificationsAnnouncements$Response(params, context).pipe(
      map((r: StrictHttpResponse<PlatformApiResultOfAnnouncementDto>): PlatformApiResultOfAnnouncementDto => r.body)
    );
  }

}
